import { EyeOutlined as EyeIcon } from "@ant-design/icons"
import { Button, Modal } from "antd"
import React, { useState } from "react"
import { isDeployEnvInternal, isNodeEnvDev } from "~Shared/utils/helper.utils"

interface JsonViewerProps {
    json: object | null
}

export const JsonViewer = ({ json }: JsonViewerProps) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleClose = () => {
        setIsOpen(false)
    }

    const isHidden = !isDeployEnvInternal && !isNodeEnvDev

    if (isHidden) {
        return null
    }

    return (
        <>
            <Modal title={"JSON"} open={isOpen} destroyOnClose keyboard width={750} onOk={handleClose} onCancel={handleClose}>
                <pre>{JSON.stringify(json, null, 2)}</pre>
            </Modal>
            <Button
                className="h-20 w-20 rounded-sm"
                icon={<EyeIcon />}
                onClick={() => {
                    setIsOpen(true)
                }}
            />
        </>
    )
}
